import React from 'react';

import style from './center.module.scss';

const Center = ({ content = <></> }) => {
  return <div className={style.center}>{content}</div>;
};

export { Center };
